// src\routes\publicRoutes.tsx
import React, { lazy, Suspense } from "react";
import { PageContentSkeleton } from "@/components/skeletons";
import { RouteObject } from "react-router-dom";

const ChatPage = lazy(() => import("@/pages/Public/ChatPage"));
const FeedbackForm = lazy(() => import("@/pages/Public/FeedbackForm"));
const ThankYou = lazy(() => import("@/pages/Public/ThankYou"));
const VerifyReslove = lazy(() => import("@/pages/Public/VerifyReslove"));
const SubscriptionSuccess = lazy(() => import("@/pages/SuperVisor/SubscriptionSuccess"));


const withSuspense = (Component: React.FC) => (
    <Suspense fallback={<PageContentSkeleton />}>
        <Component />
    </Suspense>
);


export const publicRoutes: RouteObject[] = [
    { path: "/chatbot/:chatbotId", element: withSuspense(ChatPage) },
    { path: "/feedback/:token", element: withSuspense(FeedbackForm) },
    { path: "/thank-you", element: withSuspense(ThankYou) },
    { path: "/resolve", element: withSuspense(VerifyReslove) },
    { path: "/subscription/payment-callback", element: withSuspense(SubscriptionSuccess) },
];
